import { ParkingMapComponent } from '../parking-map/parking-map.component';
import { ParkingAreaService } from '../../../services/parking-area.service';
import { Component } from '@angular/core';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { Router } from '@angular/router';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { AppConstants } from '../../../utils/AppConstants';
import { BaseSearchCriteria } from '../../../models/searchCriteria/BaseSearchCriteria';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { TooltipDirective } from '../../../utils/tooltip.directive';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { ConfirmAlertComponent } from '../../shared/confirm-alert/confirm-alert.component';
import { ThOrderingComponent } from '../../shared/th-ordering/th-ordering.component';
import { ParkingArea } from '../../../models/ParkingArea';
import { ConfirmationAlertInputComponent } from '../../shared/confirmation-alert-input/confirmation-alert-input.component';
import { FilterPanelComponent } from '../../shared/filter-panel/filter-panel.component';
import { PARKING_AREA_SEARCH_CRITERIA_KEY, ParkingAreaSearchCriteria } from '../../../models/searchCriteria/ParkingAreaSearchCriteria';
import { StorageService } from '../../../services/storage.service';
import { AlertService } from '../../shared/alert/alert.service';

@Component({
  selector: 'app-parcheggio',
  standalone: true,
  imports: [
    CommonModule,
    NgxPaginationModule,
    ThOrderingComponent,
    ParkingMapComponent,
    HasPermissionDirective,
    FilterPanelComponent,
    FormsModule,
    ReactiveFormsModule,
    TooltipDirective,
    ConfirmAlertComponent,
    ConfirmationAlertInputComponent
  ],
  templateUrl: './parking.component.html',
  styleUrl: './parking.component.scss',
})
export class ParkingComponent {
  searchForm!: FormGroup;
  emptySearchCriteria: ParkingAreaSearchCriteria = { name: undefined, pageSize: AppConstants.pageSize, pageNumber: 1 };
  searchCriteria: ParkingAreaSearchCriteria = { ...this.emptySearchCriteria };

  parkingAreaList: ParkingArea[] = [];
  selectedParking: ParkingArea | null = null;
  totalItems: number = 0;
  showConfirmationModal: boolean = false;
  confirmationMessage: string = '';
  confirmOperationType: 'DEL' | 'SWITCH-STATUS' | undefined = undefined;


  coordinatesJsonToDrawMap?: any;
  showMapModal: boolean = false;

  constructor(
    private parkingAreaService: ParkingAreaService,
    private router: Router,
    private storageService: StorageService,
    private fullSpinnerService: FullSpinnerService,
    private fb: FormBuilder,
    private alertService: AlertService
  ) {
    this.searchForm = this.fb.group({
      name: [undefined],
    });
    this.clearFilter();
    fullSpinnerService.spinner(undefined);
  }

  ngOnInit(): void {
    this.fullSpinnerService.spinner(undefined);
    if (AppConstants.storeNavigationInfo) {
      let scObj = this.storageService.retrieveNavigationInfo(PARKING_AREA_SEARCH_CRITERIA_KEY);
      if (scObj !== null) {
        this.searchCriteria = scObj;
      }
      else
        this.storageService.saveNavigationInfo(this.searchCriteria, PARKING_AREA_SEARCH_CRITERIA_KEY);
    }
    this.searchForm.patchValue(this.searchCriteria);
    this.find();
  }


  find() {
    this.fullSpinnerService.spinner('');
    this.storageService.saveNavigationInfo(this.searchCriteria, PARKING_AREA_SEARCH_CRITERIA_KEY);
    this.parkingAreaService.find(this.searchCriteria).subscribe({
      next: (res) => {
        this.parkingAreaList = res.items;
        this.totalItems = res.totalItems;
      },
      complete: () => {
        this.fullSpinnerService.spinner(undefined);
      },
      error: () => {
        this.fullSpinnerService.spinner(undefined);
      },
    });
  }

  search(): void {
    this.searchCriteria = {
      ...this.searchCriteria,
      ...this.searchForm.value
    }
    this.find();
  }

  clearFilter(withSearch: boolean = false) {
    this.searchCriteria = { ...this.emptySearchCriteria };
    this.searchForm.patchValue(this.searchCriteria);
    if (withSearch)
      this.find();
  }

 
  pageChanged(event: number) {
    this.searchCriteria.pageNumber = event;
    this.find();
  }

  edit(id?: number) {
    this.router.navigate(['parking/' + id + '/0']);
  }

  clone(id?: number) {
    this.router.navigate(['parking/' + id + '/1']);
  }

  ordering(baseSearchCriteria: BaseSearchCriteria | undefined) {
    this.searchCriteria = baseSearchCriteria as ParkingAreaSearchCriteria;
    this.find();
  }

cancelModalOperationExec() {
    this.selectedParking = null;
    this.showConfirmationModal = false;
  }

  confirmOperation(
    parkingArea: ParkingArea,
    confirmOperationType: 'DEL' | 'SWITCH-STATUS' | undefined,
    event: any
  ) {
    event.preventDefault();
    this.showConfirmationModal = true;
    this.confirmOperationType = confirmOperationType;
    if (confirmOperationType === 'DEL') {
      this.confirmationMessage =
        'Eliminazione area parcheggio - Sicuro di voler eliminare l\'area di parcheggio? ' +
        parkingArea.name;
    }
    else if (confirmOperationType === 'SWITCH-STATUS') {
      this.confirmationMessage =
        (!parkingArea.active ? 'Abilitazione' : 'Disabilitazione') + ' area parcheggio - Sicuro di voler ' + (!parkingArea.active ? 'abilitare' : 'disabilitare') + ' l\'area di parcheggio? ' +
        parkingArea.name;
    }
    this.selectedParking = parkingArea;
  }


  modalOperationExec() {
    this.fullSpinnerService.spinner('');
    if (this.confirmOperationType === 'DEL') {
      this.parkingAreaService.delete(this.selectedParking?.id!).subscribe({
        next: (value) => {
          this.alertService.addErrors(
            AppConstants.titleSuccessMessage,
            [AppConstants.successMessage],
            true
          );
          this.find();
        },
        complete: () => {
          this.fullSpinnerService.spinner(undefined);
        },
        error: (err) => {
          this.alertService.addErrors(
            AppConstants.titleErrorMessage,
            [AppConstants.errorMessage],
            true
          );
        },
      });
    } else
      if (this.confirmOperationType === 'SWITCH-STATUS') {
        this.parkingAreaService.switchStatus(this.selectedParking?.id!).subscribe({
          next: (_) => {
            this.alertService.addErrors(
              AppConstants.titleSuccessMessage,
              [AppConstants.successMessage],
              true
            );
            this.find();
          },
          complete: () => {
            this.fullSpinnerService.spinner(undefined);
          },
          error: () => {
            this.alertService.addErrors(
              AppConstants.titleErrorMessage,
              [AppConstants.errorMessage],
              true
            );
          },
        });
      }

    this.cancelModalOperationExec();
  }


  showMap(parkingArea: ParkingArea) {
    this.selectedParking = parkingArea;
    this.coordinatesJsonToDrawMap = typeof parkingArea.coordinatesJson === 'string'
      ? JSON.parse(parkingArea.coordinatesJson)
      : parkingArea.coordinatesJson;
    this.showMapModal = true;

  }

  closeMap() {
    this.showMapModal = false;
    this.coordinatesJsonToDrawMap = undefined
  }




}
